<template>
  <div class="border dborder prelative dinline-block vtop fs14 br2 ofhidden mb20" style="height: auto">
    <div class="fs16 fbold tc6 stt prelative pl15 mb10 tleft">
      <span class="vcenter dinline-block">{{item.name}}</span>
    </div>
    <div class="lh20 tleft">
      <span v-for="(item_,index_) in item.majorList" :key="index_" :item="item_" :index="index_">
        <span v-if="index_ > 0" class="dinline-block ml10 mr10">|</span>
        <router-link :to="{path:'/'+controller+'/professional/detail',query:{id:item_.id}}" class="tc9 mb10">{{item_.name}}</router-link>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "edu-list-item",
  props: [
    'item',
    'controller',
  ],
}
</script>

<style scoped>
  .dsdiv .border{margin: 0 12px; padding: 15px 25px 20px;width: 400px;height: 115px;box-shadow: 5px 5px 15px #ddd;}
  .dsdiv .border:hover{box-shadow: 0 0 15px #ccc;}
  .dsdiv .border a:hover{color: #063674;}
  .dsdiv .stt::before{content: '';position: absolute;left: 0;top: 3px;bottom: 3px;width: 4px;background: #063674;}
</style>



// WEBPACK FOOTER //
// src/components/index/edu-list-item.vue